<script setup lang="ts">
const { currentRootFolder } = useNavigation()
const { onTreeViewMounted, onTreeViewUnmounted, onUpdatedViewModeSettings } = useTreeView()
const { state: viewModeState } = useViewMode()
const { isInFolderMode } = useCollectionView()

const parentId = computed(() => currentRootFolder.value?.id)

onMounted(() => onTreeViewMounted())
onUnmounted(() => onTreeViewUnmounted())
watch(() => viewModeState.value.current, onUpdatedViewModeSettings)
</script>

<template>
  <collection-scroll-container vertical>
    <div class="spacer" />
    <div class="notes-container">
      <collection-folder-notes
        v-if="isInFolderMode() && currentRootFolder"
        :key="currentRootFolder.id"
        :folder="currentRootFolder.asStatic()"
      />
    </div>
    <div v-if="parentId" class="tree-view">
      <collection-tree-list :parent-id />
    </div>
  </collection-scroll-container>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'
.spacer
  @apply pointer-events-none w-full
  @apply h-[#{$nav-h-default}]

.notes-container
  @apply px-[#{$page-icon-p-main}] pt-[#{$page-icon-p-main}]

.tree-view
  @apply flex flex-col p-[#{$page-tree-p-main}] w-full
</style>
